import { Route, Routes } from "react-router-dom";
import CarreraGovTech from "../newPages/carreras/CarreraGovTech";
import CarreraGovTechMetodologia from "../newPages/carreras/CarreraGovTechMetologia";
import CarreraEnergia from "../newPages/carreras/CarreraEnergia";


import CarreraTurismoGastronomia from "../newPages/carreras/CarreraTurismoGastronomia";
import CarreraNegociosMetodologia from "../newPages/carreras/CarreraNegociosMetodologia";
import CarreraRecursosNaturales from "../newPages/carrerasnew/CarreraRecursosNaturales";
import CarreraRiesgos from "../newPages/carrerasnew/CarreraRiesgos";

function RoutesCarreras() {
  return (
    <>
      <Routes>
        <Route
          path="/carrera-recursos-naturales"
          element={<CarreraRecursosNaturales></CarreraRecursosNaturales>}
        />

        
        <Route
          path="/carrera-riesgos-online"
          element={<CarreraRiesgos/>}
        />

 

        <Route
          path="/carrera-govtech-online"
          element={<CarreraGovTech></CarreraGovTech>}
        />

        <Route
          path="/carrera-energia-online"
          element={<CarreraEnergia></CarreraEnergia>}
        />


        <Route
          path="/carrera-turismo-gastronomia"
          element={<CarreraTurismoGastronomia></CarreraTurismoGastronomia>}
        />
        <Route
          path="/metodologia-turismo-gastromonia"
          element={<CarreraNegociosMetodologia></CarreraNegociosMetodologia>}
        />
      </Routes>{" "}
    </>
  );
}

export default RoutesCarreras;
